export default {
  VIDEOS: "वीडियोज़",
  VIDEO: "वीडियो",
};
